export default class CookieService {
  public static getCookie(cname) {
    const cookie = document.cookie;
    return CookieService.parseCookie(cname, cookie);
  }

  public static getDecodedCookie(cname) {
    const decodedCookie = decodeURIComponent(document.cookie);
    return CookieService.parseCookie(cname, decodedCookie);
  }

  private static parseCookie(cname, cookie) {
    const name = cname + '=';
    const ca = cookie.split(';');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}
